import React from "react";
import BasicTabs from "../platform-components/basic-tabs/BasicTabs";
import Feedback from "./feedback";
import ContentFeedback from "./ContentFeedback";

const FeedbackDashboard = () => {
  const tabList = [
    {
      label: "Question Issues",
      content: <Feedback />,
    },
    {
      label: "Content Ratings",
      content: <ContentFeedback />,
    },
  ];

  return (
    <div>
      <h2>Student Feedback</h2>
      <BasicTabs tabList={tabList} />
    </div>
  );
};

export default FeedbackDashboard;
